import React, { Component } from 'react';

import InnovationCard from '../../components/InnovationCard'
import NewsCard from '../../components/NewsCard'

import { connect } from 'react-redux'
import { fetchProducts } from '../../actions/products'
import { fetchNewsList } from '../../actions/newsList'

class Search extends Component {
    state = {}

    componentDidMount = () => {
        this.props.fetchProducts()
        this.props.fetchNewsList()
    }

    render() {
        return (
            <div className="page-list-wrap">
                <div className="page-list">
                    <div className="page-list-title gapb-20">ค้นหา<div className="hr"></div></div> 
                    <div className="gapb-32">
                        <form>
                            <input 
                                type="text" 
                                className="search-input-border" 
                                placeholder="ค้นหา"
                                name="search"/>
                        </form>
                    </div>   
                    <div className="is-row search-result-wrap gapb-24">
                        <div className="search-result-item gapr-32 active">งานวิจัยและนวัตกรรม(1)</div>
                        <div className="search-result-item">ข่าวสาร(1)</div>
                    </div> 
                    <div className="is-row gapb-16 gapr--16 sm-gapr-0 flex-wrap">
                        {
                            this.props.products.map((innovation, index) => (
                                <InnovationCard key={index} innovation={innovation}/>
                            ))
                        }
                        {
                            this.props.newsList.map((news, index) => (
                                <NewsCard key={index} news={news}/>
                            ))
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return{
        auth: state.auth,
        user: state.user,
        products: state.products,
        newsList: state.newsList
    }
}

const mapDispatchToProps = {
    fetchProducts,
    fetchNewsList
}

export default connect(mapStateToProps,mapDispatchToProps)(Search)
